import { render, staticRenderFns } from "./Imoc.vue?vue&type=template&id=2e9d4d66&"
import script from "./Imoc.vue?vue&type=script&lang=js&"
export * from "./Imoc.vue?vue&type=script&lang=js&"
import style0 from "./Imoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports